import React from 'react';
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazyload';

import { prismicImage } from 'src/common/utils/prismic-image';
import cx from 'classnames';
import RichText from '../../Prismic/RichText';
import Category from './../Category';
import ImageModel from 'src/common/models/prismic/components/ImageModel';

import './Article.scss';

const Article = props => (
  <article className={cx('blog-article', {
    'hidden-xs': props.hidden
  })}>
    <a href={props.link}>
      <LazyLoad>
        <img src={prismicImage(props.image)} alt={props.image.alt}/>
      </LazyLoad>
    </a>
    <Category category={props.category} categoryLink={props.categoryLink}/>
    <a href={props.link}>
      <h4 className="text-mega blog-article-title">{props.title}</h4>
    </a>
    <RichText fields={props.content} className="blog-article-content"/>
  </article>
);

Article.propTypes = {
  image: ImageModel.propTypes.isRequired,
  link: PropTypes.string.isRequired,
  category: PropTypes.string.isRequired,
  categoryLink: PropTypes.string,
  title: PropTypes.string.isRequired,
  content: PropTypes.array.isRequired,
  hidden: PropTypes.bool
};

export default Article;



// WEBPACK FOOTER //
// ./src/client/js/view/components/BlogArticles/Article/Article.js